import { split } from "lodash";
import { TF } from "../../../components/typography/TF";

interface Props {
  quoteTitle: string | null;
}

const QuoteTopTitle = ({ quoteTitle }: Props) => {
  if (quoteTitle === null) {
    return null;
  }
  const titles = split(quoteTitle, "&");
  const mainTitle = titles[0];
  const secondTitle = titles.slice(1).join("&");
  return (
    <>
      <TF variant="h6" bold>
        {mainTitle} {titles.length > 1 ? " &" : ""}
      </TF>
      <TF variant="h6" bold>
        {secondTitle}
      </TF>
    </>
  );
};

export default QuoteTopTitle;
